
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4614"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4614"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kwU0F", function(module, exports) {

$parcel$export(module.exports, "isLocal", function () { return $83bdcabf562c83c4$export$6dd1bbd39f571125; });
$parcel$export(module.exports, "isDemo", function () { return $83bdcabf562c83c4$export$7a7fb88e277126a7; });
$parcel$export(module.exports, "isDev", function () { return $83bdcabf562c83c4$export$40edfb7eeb78c4e8; });
$parcel$export(module.exports, "request", function () { return $83bdcabf562c83c4$export$b5fe3f66a567bec0; });
$parcel$export(module.exports, "requestWithAuth", function () { return $83bdcabf562c83c4$export$51eb31d87a56849c; });
let $83bdcabf562c83c4$var$apiUrl;
let $83bdcabf562c83c4$var$isDemoEnvironment = false;
let $83bdcabf562c83c4$var$isDevEnvironment = false;
if (window.location.hostname === "localhost") $83bdcabf562c83c4$var$apiUrl = "http://localhost:9090/";
else if (window.location.hostname.startsWith("dev-app")) {
    $83bdcabf562c83c4$var$apiUrl = "https://dev-api.ommej.se/";
    $83bdcabf562c83c4$var$isDevEnvironment = true;
} else if (window.location.hostname.startsWith("demo-app")) {
    $83bdcabf562c83c4$var$apiUrl = "https://demo-api.ommej.se/";
    $83bdcabf562c83c4$var$isDemoEnvironment = true;
} else $83bdcabf562c83c4$var$apiUrl = "https://api.ommej.se/";
const $83bdcabf562c83c4$export$6dd1bbd39f571125 = window.location.hostname === "localhost";
const $83bdcabf562c83c4$export$7a7fb88e277126a7 = $83bdcabf562c83c4$var$isDemoEnvironment;
const $83bdcabf562c83c4$export$40edfb7eeb78c4e8 = $83bdcabf562c83c4$var$isDevEnvironment;
const $83bdcabf562c83c4$export$b5fe3f66a567bec0 = async (path, method, payload)=>{
    const body = payload ? JSON.stringify(payload) : undefined;
    const response = await fetch($83bdcabf562c83c4$var$apiUrl + path, {
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        method: method,
        body: body
    });
    if (response.ok) return response;
    throw response;
};
const $83bdcabf562c83c4$export$51eb31d87a56849c = async (path, method, token, payload)=>{
    const body = payload ? JSON.stringify(payload) : undefined;
    const response = await fetch($83bdcabf562c83c4$var$apiUrl + path, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        credentials: "include",
        method: method,
        body: body
    });
    if (response.ok) return response;
    throw response;
};

});

/* eslint-disable import/no-unused-modules  */ 
var $kwU0F = parcelRequire("kwU0F");
const $3a2c19ae02ed8566$var$trackUrl = "https://misc.ommej.se/umami/script.js";
const $3a2c19ae02ed8566$var$devId = "6dd54313-5374-4181-9bf6-61d3a12dd797";
const $3a2c19ae02ed8566$var$demoId = "f36a1118-2886-4600-852b-e324418c603a";
const $3a2c19ae02ed8566$var$prodId = "fd0993d6-39c3-4d5f-9f04-89c0621e5b04";
const $3a2c19ae02ed8566$var$createScriptTag = (environmentId)=>{
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute("defer", "");
    script.setAttribute("async", "");
    script.dataset.websiteId = environmentId;
    script.dataset.doNotTrack = "true";
    script.setAttribute("src", $3a2c19ae02ed8566$var$trackUrl);
    if (head) head.appendChild(script);
};
const $3a2c19ae02ed8566$var$loadTrackerScript = ()=>{
    if (0, $kwU0F.isLocal) return;
    if (0, $kwU0F.isDev) $3a2c19ae02ed8566$var$createScriptTag($3a2c19ae02ed8566$var$devId);
    else if (0, $kwU0F.isDemo) $3a2c19ae02ed8566$var$createScriptTag($3a2c19ae02ed8566$var$demoId);
    else $3a2c19ae02ed8566$var$createScriptTag($3a2c19ae02ed8566$var$prodId);
};
$3a2c19ae02ed8566$var$loadTrackerScript();


//# sourceMappingURL=index.cde2a98f.js.map
